// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type MaterialCatalogFilterMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MaterialCatalogFilterMetadataQuery = { __typename?: 'Query', materialBrands: Array<{ __typename?: 'MaterialBrand', id: string, name: string }>, items: Array<{ __typename?: 'Item', id: string, name: string }>, materialVariantTags: Array<{ __typename?: 'MaterialVariantTag', id: string, name: string }> };

export type MaterialCatalogFilterDimensionsQueryVariables = Types.Exact<{
  itemId: Types.Scalars['String']['input'];
}>;


export type MaterialCatalogFilterDimensionsQuery = { __typename?: 'Query', materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> }> };

export type MaterialCatalogFilter_MaterialBrandFragment = { __typename?: 'MaterialBrand', id: string, name: string };

export type MaterialCatalogFilter_MaterialAttributeDimensionFragment = { __typename?: 'MaterialAttributeDimension', id: string, name: string, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> };

export const MaterialCatalogFilter_MaterialBrandFragmentDoc = gql`
    fragment MaterialCatalogFilter_MaterialBrand on MaterialBrand {
  id
  name
}
    `;
export const MaterialCatalogFilter_MaterialAttributeDimensionFragmentDoc = gql`
    fragment MaterialCatalogFilter_MaterialAttributeDimension on MaterialAttributeDimension {
  id
  name
  values {
    id
    textValue
  }
}
    `;
export const MaterialCatalogFilterMetadataDocument = gql`
    query MaterialCatalogFilterMetadata {
  materialBrands(filter: {}) {
    ...MaterialCatalogFilter_MaterialBrand
  }
  items(filter: {version: 2}) {
    ...Named
  }
  materialVariantTags {
    ...Named
  }
}
    ${MaterialCatalogFilter_MaterialBrandFragmentDoc}
${NamedFragmentDoc}`;

/**
 * __useMaterialCatalogFilterMetadataQuery__
 *
 * To run a query within a React component, call `useMaterialCatalogFilterMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialCatalogFilterMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialCatalogFilterMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useMaterialCatalogFilterMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MaterialCatalogFilterMetadataQuery, MaterialCatalogFilterMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MaterialCatalogFilterMetadataQuery, MaterialCatalogFilterMetadataQueryVariables>(MaterialCatalogFilterMetadataDocument, options);
      }
export function useMaterialCatalogFilterMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MaterialCatalogFilterMetadataQuery, MaterialCatalogFilterMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MaterialCatalogFilterMetadataQuery, MaterialCatalogFilterMetadataQueryVariables>(MaterialCatalogFilterMetadataDocument, options);
        }
// @ts-ignore
export function useMaterialCatalogFilterMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MaterialCatalogFilterMetadataQuery, MaterialCatalogFilterMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MaterialCatalogFilterMetadataQuery, MaterialCatalogFilterMetadataQueryVariables>;
export function useMaterialCatalogFilterMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialCatalogFilterMetadataQuery, MaterialCatalogFilterMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MaterialCatalogFilterMetadataQuery | undefined, MaterialCatalogFilterMetadataQueryVariables>;
export function useMaterialCatalogFilterMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialCatalogFilterMetadataQuery, MaterialCatalogFilterMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MaterialCatalogFilterMetadataQuery, MaterialCatalogFilterMetadataQueryVariables>(MaterialCatalogFilterMetadataDocument, options);
        }
export type MaterialCatalogFilterMetadataQueryHookResult = ReturnType<typeof useMaterialCatalogFilterMetadataQuery>;
export type MaterialCatalogFilterMetadataLazyQueryHookResult = ReturnType<typeof useMaterialCatalogFilterMetadataLazyQuery>;
export type MaterialCatalogFilterMetadataSuspenseQueryHookResult = ReturnType<typeof useMaterialCatalogFilterMetadataSuspenseQuery>;
export type MaterialCatalogFilterMetadataQueryResult = ApolloReactCommon.QueryResult<MaterialCatalogFilterMetadataQuery, MaterialCatalogFilterMetadataQueryVariables>;
export const MaterialCatalogFilterDimensionsDocument = gql`
    query MaterialCatalogFilterDimensions($itemId: String!) {
  materialAttributeDimensions(filter: {itemId: $itemId}) {
    ...MaterialCatalogFilter_MaterialAttributeDimension
  }
}
    ${MaterialCatalogFilter_MaterialAttributeDimensionFragmentDoc}`;

/**
 * __useMaterialCatalogFilterDimensionsQuery__
 *
 * To run a query within a React component, call `useMaterialCatalogFilterDimensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialCatalogFilterDimensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialCatalogFilterDimensionsQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *   },
 * });
 */
export function useMaterialCatalogFilterDimensionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MaterialCatalogFilterDimensionsQuery, MaterialCatalogFilterDimensionsQueryVariables> & ({ variables: MaterialCatalogFilterDimensionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MaterialCatalogFilterDimensionsQuery, MaterialCatalogFilterDimensionsQueryVariables>(MaterialCatalogFilterDimensionsDocument, options);
      }
export function useMaterialCatalogFilterDimensionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MaterialCatalogFilterDimensionsQuery, MaterialCatalogFilterDimensionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MaterialCatalogFilterDimensionsQuery, MaterialCatalogFilterDimensionsQueryVariables>(MaterialCatalogFilterDimensionsDocument, options);
        }
// @ts-ignore
export function useMaterialCatalogFilterDimensionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MaterialCatalogFilterDimensionsQuery, MaterialCatalogFilterDimensionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MaterialCatalogFilterDimensionsQuery, MaterialCatalogFilterDimensionsQueryVariables>;
export function useMaterialCatalogFilterDimensionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialCatalogFilterDimensionsQuery, MaterialCatalogFilterDimensionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MaterialCatalogFilterDimensionsQuery | undefined, MaterialCatalogFilterDimensionsQueryVariables>;
export function useMaterialCatalogFilterDimensionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialCatalogFilterDimensionsQuery, MaterialCatalogFilterDimensionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MaterialCatalogFilterDimensionsQuery, MaterialCatalogFilterDimensionsQueryVariables>(MaterialCatalogFilterDimensionsDocument, options);
        }
export type MaterialCatalogFilterDimensionsQueryHookResult = ReturnType<typeof useMaterialCatalogFilterDimensionsQuery>;
export type MaterialCatalogFilterDimensionsLazyQueryHookResult = ReturnType<typeof useMaterialCatalogFilterDimensionsLazyQuery>;
export type MaterialCatalogFilterDimensionsSuspenseQueryHookResult = ReturnType<typeof useMaterialCatalogFilterDimensionsSuspenseQuery>;
export type MaterialCatalogFilterDimensionsQueryResult = ApolloReactCommon.QueryResult<MaterialCatalogFilterDimensionsQuery, MaterialCatalogFilterDimensionsQueryVariables>;